import React from 'react';
import { useParams } from 'react-router-dom';

import ColoredOverlayWindow from 'src/legacy/Components/Windows/ColoredOverlayWindow';

import { useEventHistory } from '../hooks';
import { useCheckoutStore } from '../stores';

const CheckoutRejected = () => {
  const { eventID } = useParams();
  const eventHistory = useEventHistory();
  const { clearEventCheckout } = useCheckoutStore();

  const goToPage = () => {
    eventHistory.replace(`/event/${eventID}/checkout/payment`);
  };

  React.useEffect(() => {
    clearEventCheckout(eventID!);
  }, [clearEventCheckout, eventID]);

  return (
    <ColoredOverlayWindow
      show={true}
      title="Compra não foi aprovada"
      requestStatus="denied"
      buttonText={undefined}
      {...{ goToPage }}>
      Seu pagamento não foi aprovado pelo banco, confira se digitou o código de
      segurança correto. Verifique seu limite. Caso esteja utilizando um cartão
      virtual, confira se esse cartão ainda está ativo. Você pode adicionar um
      novo cartão, tentar pagar com esse novamente ou pagar com PIX.
    </ColoredOverlayWindow>
  );
};

export default CheckoutRejected;
